export const EXPORT_SINGLE_CLIENT_REPORT_PDF_MESSAGES = {
  NOT_FOUND: 'No report was found',
};


// WEBPACK FOOTER //
// ./src/features/reports/constants/exportSingleClientReportPdfContants.js